export const PER_PAGE = 10;
export const CATEGORY_TYPE = {
  PRESS: 1,
  NEWS: 2,
};
